module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_50-a3bbdbd08b785b6566c7996cc78e32e4.png";